import UAParser from 'ua-parser-js';
import { makeDebugger } from '@lib';

const debug = makeDebugger('isAndroidOrIOS');

export function isAndroidOrIOS(): boolean {
  const parsedUA: typeof UAParser['prototype'] =
    (isAndroidOrIOS as any).parsedUA || new UAParser(window.navigator.userAgent);
  const OSName = parsedUA.getOS().name;

  debug(`Checking OS name: ${OSName}`, parsedUA);
  return OSName === 'Android' || OSName === 'iOS';
}
